import { useState } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/categories", label: "分类大全" },
  { to: "/rankings", label: "人气榜单" },
  { to: "/about", label: "关于我们" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur-md border-b border-background-200/70">
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5" aria-label="正版韩漫大全首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="font-heading text-lg md:text-xl text-primary-600">
            韩漫大全
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-600 whitespace-nowrap"
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-800">
            <i className="ri-verified-badge-fill"></i>
            正版授权
          </span>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 text-foreground-700 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="切换导航菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <div className="flex flex-col gap-1 pt-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-600"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}